import getConfig from 'next/config';
import { getFeaturesFromRequest } from './utils';
export var isDataDogRumEnrolled = function (_a) {
    var _b, _c;
    var req = _a.req, pathname = _a.pathname;
    var publicRuntimeConfig = getConfig().publicRuntimeConfig;
    var baseConfig = publicRuntimeConfig.datadog;
    var routeEnrolment = pathname && ((_b = baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.rum) === null || _b === void 0 ? void 0 : _b.routeEnrolment)
        ? baseConfig.rum.routeEnrolment[pathname]
        : undefined;
    var rumEnrolment = 
    // undefined means there is no route-specific enrolment setting
    typeof routeEnrolment === 'undefined'
        ? ((_c = baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.rum) === null || _c === void 0 ? void 0 : _c.enrolment) || false
        : routeEnrolment;
    if (typeof rumEnrolment === 'boolean') {
        return rumEnrolment;
    }
    var enrolments = req ? getFeaturesFromRequest(req) : [];
    return enrolments.includes(rumEnrolment);
};
